// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Surface Layer System */
.vnsc-root {
  --vnsc-surface-0: var(--vnsc-bg-primary);
  --vnsc-surface-1: var(--vnsc-bg-secondary);
  --vnsc-surface-2: var(--vnsc-bg-tertiary);
  --vnsc-surface-3: var(--vnsc-bg-elevated);
  --vnsc-surface-4: var(--vnsc-bg-elevated);
}

.vnsc-root[data-chart-mode="light"] {
  --vnsc-surface-4: #e2e8f0;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/surfaces.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Design Tokens - Surface Layer System */\r\n.vnsc-root {\r\n  --vnsc-surface-0: var(--vnsc-bg-primary);\r\n  --vnsc-surface-1: var(--vnsc-bg-secondary);\r\n  --vnsc-surface-2: var(--vnsc-bg-tertiary);\r\n  --vnsc-surface-3: var(--vnsc-bg-elevated);\r\n  --vnsc-surface-4: var(--vnsc-bg-elevated);\r\n}\r\n\r\n.vnsc-root[data-chart-mode=\"light\"] {\r\n  --vnsc-surface-4: #e2e8f0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
